import { evidenceCapabilitiesAtom } from '@/atoms/evidenceCapabilitiesAtoms';
import { useQueryEvidenceCapabilities } from '@heidi/evidence/data';
import { useSetAtom } from 'jotai';
import { useEffect } from 'react';

/**
 * Publishes what Evidence chat can do in this deployment into
 * `evidenceCapabilitiesAtom` (MOD-1726). Renders nothing. On a cloud build the
 * read makes no request and the value it publishes is the atom's own default.
 */
export const EvidenceCapabilitiesSync = (): null => {
  const capabilities = useQueryEvidenceCapabilities();
  const publish = useSetAtom(evidenceCapabilitiesAtom);

  useEffect(() => {
    publish(capabilities);
  }, [capabilities, publish]);

  return null;
};
